// Generated by CoffeeScript 2.7.0
var i18n;

i18n = {
  querygroup: {
    type: {
      author: '发送者',
      type: '类型',
      tag: '标签',
      published_at: '发送时间',
      order: '排序方式'
    },
    options: {
      all: '所有',
      form: '表单',
      post: '普通通知',
      template_post: '模版通知',
      week_less: '1周内',
      month_less: '1月内',
      year_less: '1年内',
      year_ago: '1年前',
      custom_range: '自定义范围',
      desc: '发布时间降序',
      asc: '发布时间升序',
      best_match: '最佳匹配'
    }
  },
  filterParam: {
    type: {
      tag_id: '标签',
      state: '状态',
      type: '类型'
    },
    options: {
      template_post: '模版通知',
      post: '普通通知',
      form: '表单',
      unread: '未读',
      uncompleted: '未完成',
      completed: '已完成'
    }
  },
  pushes: {
    type: {
      'custom_message': '微信推送',
      'Push::CustomMessage': '微信推送',
      'sms': '短信推送',
      'Push::Sms': '短信推送',
      'call': '电话推送',
      'Push::Call': '电话推送'
    },
    push_packageable_type: {
      User: '用户',
      Namespace: '系统'
    },
    recipient_types: {
      unread: '未读',
      unfill: '未填',
      uncompleted: '未完成'
    }
  },
  redPacketSetting: {
    statuses: {
      preparing: '准备中',
      sending: '发送中',
      closed: '已关闭',
      expired: '已过期',
      exhausted: '已被领光',
      notenough: '账户余额不足',
      already_opened: '已经拆过了'
    }
  },
  field: {
    type: {
      'Field::TextField': '单行',
      'Field::TextArea': '多行',
      'Field::Integer': '数字',
      'Field::IDNumber': '身份证号',
      'Field::Phone': '手机号',
      'Field::Calculation': '计算字段',
      'Field::RadioButton': '单选',
      'Field::CheckBox': '多选',
      'Field::DateTime': '日期时间',
      'Field::CascadedSelect': '级联选择',
      'Field::File': '文件上传',
      'Field::Rating': '星级评分',
      'Field::Organization': '组织选择',
      'Field::Member': '成员选择',
      'Field::Location': '地理位置',
      'Field::Detail': '明细清单',
      'Field::SectionBreak': '章节',
      'text': '文本输入',
      'selection': '选择输入',
      'datetime': '日期时间',
      'datetime-local': '日期和时间',
      'date': '日期',
      'time': '时间',
      'Field::Esignature': '电子签字'
    },
    layout: {
      'block': '区块',
      'inline': '平铺',
      'select': '下拉',
      'list': '列表'
    },
    visibility: {
      'public_visibility': '所有人能填',
      'next_phase_visibility': '下一层级可见',
      'protected_visibility': '用户只能查看不能填写',
      'private_visibility': '仅管理员能看到'
    },
    limitSettingText: {
      'Field::TextField': '限定字数',
      'Field::TextArea': '限定字数',
      'Field::Integer': '限定数值范围'
    },
    fillSetting: {
      wechat_scan: {
        title: '使用微信扫码输入',
        tip: '在微信中打开就可以使用扫码录入功能，扫码后会自动提取二维码/条形码信息填入字段。请注意，由于微信安全域名限制，自定义域名表单该功能将失效'
      },
      uniqueness_validation: {
        title: '不允许重复值',
        tip: '勾选后，该字段将不允许提交重复值。如果提交值已存在，提交将失败'
      },
      limit_setting: {
        title: '限定数值范围',
        tip: '勾选可以设置输入字段的字数范围'
      },
      char_size_limit_setting: {
        'title': '限定字数',
        'tip': '可设置输入字数限制'
      },
      location_watermark: {
        title: '添加地址水印',
        tip: '在文件上传时，提交图片格式的文件后会在图片上添加当前地址水印'
      },
      datetime_watermark: {
        title: '添加日期时间水印',
        tip: '在文件上传时，提交图片格式的文件后会在图片上添加当前日期时间水印'
      }
    },
    userSettings: {
      register_writed: '注册时要填写',
      explicit: '在用户页面显示',
      enable_modify: '用户可以修改'
    },
    logic: {
      range: {
        'eq': '等于',
        'gt': '大于',
        'lt': '小于',
        'gteq': '大于等于',
        'lteq': '小于等于',
        'in': '两数之间'
      }
    },
    response_search_fields: {
      'Field::HoldUser': '填写用户',
      'Field::HoldCreatedAt': '填写时间',
      'Field::TextField': '单行文本',
      'Field::Rating': '星级评分',
      'Field::Integer': '数字',
      'Field::Organization': '组织选择',
      'Field::Member': '成员选择',
      'Field::DateTime': '日期时间'
    }
  },
  assignment: {
    operates: {
      approve: '通过',
      refuse: '回退',
      cancel: '撤销',
      stash: '保存',
      commit: '下一步',
      transfer: '转交',
      remind: '催促',
      propose: '发起',
      comment: '处理意见',
      esignature: '电子签字',
      limit_time: '设置下级时限',
      carbon_copy: '手动抄送',
      repropose: '再次提交'
    },
    approve: {
      '1': '非必填',
      '2': '必填'
    },
    refuse: {
      '3': '回退任意节点',
      '2': '回到上一个节点',
      '1': '回到发起者节点',
      reviewer: {
        '0': '回到所有处理者',
        '1': '回到动态处理者'
      }
    },
    security: {
      public: '对外公开',
      private: '对外保密'
    },
    status: {
      stashed: '编写中',
      processing: '正在处理中',
      approved: '已通过',
      refused: '已回退',
      transferred: '已转交',
      skipped: '已被处理',
      cancelled: '已撤销',
      receding: '回退中',
      suspended: '异常',
      finished: '完成',
      aborted: '管理员终止'
    },
    skippedStatus: {
      approved: '通过',
      refused: '回退',
      cancelled: '已撤销'
    },
    esignature: '电子签字'
  },
  journey: {
    status: {
      processing: '处理中',
      finished: '已完成',
      suspended: '异常',
      stashed: '编写中',
      cancelled: '已撤回',
      receding: '回退中',
      aborted: '管理员终止'
    }
  },
  material: {
    type: {
      'image': '图片',
      'video': '视频',
      'material': '素材'
    }
  },
  sort: {
    desc: '降序',
    asc: '升序',
    best_match: '最佳匹配'
  },
  comment: {
    status: {
      comment_must_approved: '审核后通过',
      comment_auto_approved: '自动通过',
      comment_closed: '关闭'
    }
  },
  organization: {
    move_to_another_organization: '移至下属组织',
    move_to_root: '移至顶级组织'
  },
  release: {
    status: {
      release_personal: '以个人名义发布',
      release_organization: '以组织名义发布'
    }
  },
  settings: {
    inside_settings: {
      settings__basic: '空间设置',
      user_profile__schema: '用户属性设置',
      organization_profile__schema: '组织属性设置',
      settings__administrations: '空间管理员设置',
      settings__red_packet_quotas: '红包额度设置'
    },
    other_settings: {
      settings__menu: '微信菜单设置',
      settings__namecard: '名片模板设置',
      settings__welcome: '欢迎消息设置',
      settings__templates: '模板设置',
      settings__brand_images_preferences: '绑定样式设置',
      settings__help_html: '联系管理员文案设置',
      settings__message_exception_templates: '消息异常模板设置'
    },
    namespace_settings_tab: {
      settings__basic: '基础设置',
      settings__push_template: '推送模板（新）',
      settings__tencent_wecity: '实名核身',
      settings__customer_service: '客服功能',
      settings__attendance: '签到功能',
      settings__register: '注册&组织',
      settings__wechat_authorized: '三方授权',
      settings__wechat_pay: '微信支付',
      settings__namespace_status: '空间状态',
      settings__others: '其他功能'
    },
    register: {
      fuzzy_matching: '模糊匹配',
      exact_matching: '精准匹配'
    },
    allocated_amount: {
      increase_amount: '增加额度',
      decrease_amount: '减少额度'
    }
  },
  form: {
    after_submit_actions: {
      default: '默认',
      show_message: '显示指定内容',
      redirect: '跳转到指定页面',
      show_statistication: '跳转到统计页面'
    },
    fields_attributes: '表项',
    chart_type: {
      'horizontalBar': '水平条状图',
      'bar': '柱形图',
      'pie': '扇形图'
    }
  },
  message: {
    title: '标题',
    html_body: '正文',
    field: '表项',
    actions: {
      publish: '发布',
      preview: '预览',
      save: '保存'
    },
    page: '分页',
    cascaded_select: '级联关系',
    detail: '明细字段',
    identifier: '识别码',
    phone: '手机号码'
  },
  rangePosition: {
    start: '开始',
    end: '结束'
  },
  date: {
    unit: {
      minutes: '分钟',
      hours: '小时',
      days: '天',
      years: '年',
      months: '月',
      weeks: '周',
      seconds: '秒'
    },
    businessTime: {
      workday: '工作日',
      everyday: '每天'
    }
  },
  yaw: {
    vertices: {
      user_boundary: '处理者范围'
    }
  },
  yaw_vertex: {
    user_boundary: {
      base: '处理者范围'
    },
    push: {
      type: {
        'Push::CustomMessage': '微信推送',
        'Push::Sms': '短信推送',
        'Push::Call': '电话推送',
        'Push::Webhook': '第三方'
      },
      time: {
        created: '到达节点时',
        updated: '节点处理时',
        time_up: '逾期时'
      },
      scope: {
        review: '处理者',
        cc: '抄送者'
      }
    }
  }
};

export var getZH_CN = function(path, divider) {
  var i, key, keys, len, result;
  Deprecation.warn('getZH_CN', 'replace it with Skylark.Helpers.translate or Skylark.Helpers.t');
  keys = path.split(divider || '.');
  result = i18n;
  for (i = 0, len = keys.length; i < len; i++) {
    key = keys[i];
    if (!key) {
      continue;
    }
    if (!result) {
      break;
    }
    result = result[key];
  }
  if (_.isBlank(result)) {
    throw new Error(`translation missing ${keys.join('.')}`);
  } else {
    return result;
  }
};

export var translate = function(attribute, options = {}) {
  var i, key, keys, len, parts, result;
  // options
  //   - raise::boolean
  //   - scope::array
  parts = attribute.split(".");
  attribute = parts.pop();
  keys = (options.scope || []).concat(parts, attribute);
  result = i18n;
  for (i = 0, len = keys.length; i < len; i++) {
    key = keys[i];
    if (!key) {
      continue;
    }
    if (!result) {
      break;
    }
    result = result[key];
  }
  if (_.isBlank(result)) {
    if (options.raise) {
      throw new Error(`translation missing ${keys.join('.')}`);
    }
  } else {
    return result;
  }
};

export var t = function() {
  return translate.apply(null, arguments);
};

export default {
  t: t,
  translate: translate
};
